module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7c417cd2ff5d03f924e0ec8f380ad972.svg";